import React from 'react'
import TextField from '@material-ui/core/TextField'
import {onUnknownChangeHandler} from 'lib/dom'
import CloseIcon from '@material-ui/icons/Close'
import EmojiSelect from 'Event/Dashboard/components/EmojiList/EmojiSelect'
import EmojiUpload from 'Event/Dashboard/components/EmojiList/EmojiUpload'
import styled from 'styled-components'
import IconButton from 'lib/ui/IconButton'
import {
  DEFAULT_EMOJIS,
  createCustomEmoji,
  Emoji,
} from 'Event/Dashboard/components/EmojiList/emoji'

export default function Settings(props: {
  emojiWidth?: number | null
  setEmojiWidth: (newEmojiWidth: number) => void
  emojis: string[]
  setEmojis: (newEmojis: string[]) => void
  addCustomEmoji: (emojiName: Emoji['name']) => void
  removeCustomEmoji: (emojiName: Emoji['name']) => void
  customEmojis: Emoji['name'][]
}) {
  const {
    emojiWidth,
    setEmojiWidth,
    emojis,
    setEmojis,
    addCustomEmoji,
    removeCustomEmoji,
    customEmojis,
  } = props

  const customEmojisWithImage = customEmojis.map(createCustomEmoji)
  const availableEmojis = [...DEFAULT_EMOJIS, ...customEmojisWithImage]

  const updateEmoji = (index: number) => (target: Emoji['name']) => {
    const updated = emojis.map((e, i) => {
      const isTarget = i === index
      if (isTarget) {
        return target
      }

      return e
    })

    setEmojis(updated)
  }

  const addNewEmoji = (emoji: Emoji['name']) => {
    const added = [...emojis, emoji]
    setEmojis(added)
  }

  const remove = (index: number) => () => {
    const removed = emojis.filter((e, i) => i !== index)
    setEmojis(removed)
  }

  return (
    <>
      <h3>Settings</h3>
      <TextField
        type="number"
        value={emojiWidth || ''}
        label="Emoji Size"
        onChange={onUnknownChangeHandler(setEmojiWidth)}
        fullWidth
        inputProps={{
          step: 5,
          min: 20,
        }}
      />
      <h3>Emojies</h3>
      <ExistingEmojiesHolder>
        {emojis.map((emoji, index) => (
          <ExistingEmoji key={index}>
            <EmojiSelect
              emojis={availableEmojis}
              value={emoji}
              onPick={updateEmoji(index)}
              label=""
            />
            <RemoveButton aria-label="remove emoji" onClick={remove(index)}>
              <CloseIcon color="error" />
            </RemoveButton>
          </ExistingEmoji>
        ))}
      </ExistingEmojiesHolder>
      <EmojiSelect
        value=""
        emojis={availableEmojis}
        onPick={addNewEmoji}
        label="Add Emoji"
      />

      <h3>Custom Emojies</h3>

      <EmojiUpload onSuccess={addCustomEmoji} />

      <CustomEmojiList>
        {customEmojis.map((emoji, index) => (
          <CustomEmojiItem key={index}>
            <Image src={createCustomEmoji(emoji).image} alt={emoji} />
            <RemoveCustomEmojiButton
              aria-label="remove custom emoji"
              onClick={() => {
                removeCustomEmoji(emoji)
              }}
            >
              <CloseIcon color="error" />
            </RemoveCustomEmojiButton>
          </CustomEmojiItem>
        ))}

        {customEmojis.length === 0 && <p>No custom emojies</p>}
      </CustomEmojiList>
    </>
  )
}

const CustomEmojiList = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
`

const CustomEmojiItem = styled.div`
  display: flex;
  background: #ffffff;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
`

const ExistingEmoji = styled.div`
  display: flex;
  align-items: center;
  width: 31%;
`

const ExistingEmojiesHolder = styled.div`
  display: flex;
  gap: 3.33%;
  flex-wrap: wrap;
`

const RemoveButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
  margin-top: -${(props) => props.theme.spacing[10]};
`

const RemoveCustomEmojiButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
`
const Image = styled.img`
  width: 30px;
`
